let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qq9U")).then(() => parcelRequire('iLucK'));